export function dedupeRepositoryContextSources<T extends { name: string; kind?: string | null }>(
  items: T[],
): T[] {
  const seenRepoNames = new Set<string>()
  return items.filter((item) => {
    if (item.kind?.toLowerCase() !== 'repository') return true
    if (seenRepoNames.has(item.name)) return false
    seenRepoNames.add(item.name)
    return true
  })
}
